import cx from 'classnames';
import PropTypes from 'prop-types';
import { DraggableDrawer, RadioButton } from '@bwoty-web/ui-kit';

import './sortPanel.scss';

const SortPanel = ({
  closeSortPanel,
  isMobile,
  selectedSortOrder,
  sortAction,
  sortOptions,
  sortPanelIsVisible,
  wrapperRef,
}) => (
  <DraggableDrawer
    defaultHeight={40}
    disabled={!isMobile}
    onClose={closeSortPanel}
    show={sortPanelIsVisible}
  >
    <div
      className={cx('iw-srp-list__sort-wrapper', {
        'iw-srp-list__sort-wrapper--show': sortPanelIsVisible,
      })}
      ref={wrapperRef}
    >
      <div className="iw-srp-list__sort-main">
        <ul>
          {sortOptions.map((option) => (
            <li
              key={option.value}
              className={cx('iw-srp-list__sort-list-item', {
                'iw-srp-list__sort-list-item--selected': selectedSortOrder === option.value,
              })}
            >
              <RadioButton
                checked={selectedSortOrder === option.value}
                className="iw-srp-list__sort-radio-button"
                name={option.value}
                onChange={() => sortAction(option.value)}
                uniqueId={option.value}
              >
                {option.name}
              </RadioButton>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </DraggableDrawer>
);

SortPanel.propTypes = {
  closeSortPanel: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  selectedSortOrder: PropTypes.string.isRequired,
  sortAction: PropTypes.func.isRequired,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  sortPanelIsVisible: PropTypes.bool.isRequired,
  wrapperRef: PropTypes.shape({}).isRequired,
};

export default SortPanel;
